import { useAuth0 as useAuth0 } from '@auth0/auth0-react';
import { AuthHookData2x0lxghdz8ao as AuthHookData } from './AuthHookData.mjs';
import { awaitd1m8y0em728c as await_0 } from '../../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Promise.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { json3n35pf5np6si4 as json } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/json.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function useAuth0Data() {
  var hook = useAuth0();
  var tmp = hook.isAuthenticated === true ? hook.user : null;
  var tmp_0 = hook.isAuthenticated === true;
  var tmp_1 = hook.isLoading === true;
  var tmp_2 = hook.error;
  var tmp_3 = Auth0Hook$loginWithRedirect$ref(hook);
  var tmp_4 = useAuth0Data$slambda_0(hook);
  var tmp_5 = Auth0Hook$logout$ref(hook);
  return new (AuthHookData())(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, useAuth0Data$slambda_2(hook));
}
function *collectRawToken(_this__u8e3s4, $completion) {
  return toString((yield* await_0(_this__u8e3s4, $completion))['__raw']);
}
function Auth0Hook$loginWithRedirect$ref(p0) {
  var l = (_this__u8e3s4) => {
    p0.loginWithRedirect(_this__u8e3s4);
    return Unit_instance;
  };
  l.callableName = 'loginWithRedirect';
  return l;
}
var useAuth0Data$slambdaClass;
function useAuth0Data$slambda() {
  if (useAuth0Data$slambdaClass === VOID) {
    class $ {
      constructor($hook) {
        this.o3s_1 = $hook;
      }
      *p3s($completion) {
        var tmp;
        if (this.o3s_1.isAuthenticated === true) {
          tmp = yield* /*#__NOINLINE__*/collectRawToken(this.o3s_1.getIdTokenClaims(), $completion);
        } else {
          tmp = '';
        }
        return tmp;
      }
      nd($completion) {
        return this.p3s($completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    useAuth0Data$slambdaClass = $;
  }
  return useAuth0Data$slambdaClass;
}
function useAuth0Data$slambda_0($hook) {
  var i = new (useAuth0Data$slambda())($hook);
  var l = ($completion) => i.p3s($completion);
  l.$arity = 0;
  return l;
}
function Auth0Hook$logout$ref(p0) {
  var l = (_this__u8e3s4) => {
    p0.logout(_this__u8e3s4);
    return Unit_instance;
  };
  l.callableName = 'logout';
  return l;
}
var useAuth0Data$slambdaClass_0;
function useAuth0Data$slambda_1() {
  if (useAuth0Data$slambdaClass_0 === VOID) {
    class $ {
      constructor($hook) {
        this.q3s_1 = $hook;
      }
      *p3s($completion) {
        return yield* await_0(this.q3s_1.getAccessTokenSilently(json([to('audience', 'https://' + window.location.hostname + '/api'), to('scope', 'email')])), $completion);
      }
      nd($completion) {
        return this.p3s($completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    useAuth0Data$slambdaClass_0 = $;
  }
  return useAuth0Data$slambdaClass_0;
}
function useAuth0Data$slambda_2($hook) {
  var i = new (useAuth0Data$slambda_1())($hook);
  var l = ($completion) => i.p3s($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  useAuth0Data as useAuth0Datar84ij8t1ru66,
};
//endregion

//# sourceMappingURL=Dsl.mjs.map
